import { erpAxios } from '.';

const fetchRegistry = async () => {
  const { data } = await erpAxios(`web-zahtjevi/registri/loanofficer`);
  return data;
};

export default fetchRegistry;
